import { useMissionStore } from '../../shared/store/useMissionStore';
import { useMissionDetailingStore } from '../store/useMissionDetailingStore';
import { useMission } from '../../shared/hooks/useMission';
import { useEffect } from 'react';

export const useRoot = () => {
  const { missionResult, errors } = useMission();
  const missionPage = useMissionDetailingStore((state) => state.missionPage);
  const mission = useMissionStore((state) => state.mission);
  const setMissionPage = useMissionDetailingStore((state) => state.setMissionPage);

  useEffect(() => {
    if (missionResult) {
      setMissionPage(missionResult);
    }
  }, [missionResult, setMissionPage]);

  return {
    mission,
    missionPage,
    errors,
  };
};
